import React from 'react';
import { Shield, Award, CheckCircle, Star, TrendingUp, Users } from 'lucide-react';

const TrustBadges = () => {
  const badges = [
    {
      icon: Shield,
      text: 'Government Verified',
      color: 'text-blue-600',
      bg: 'bg-blue-50'
    },
    {
      icon: Award,
      text: '10+ Years Experience',
      color: 'text-purple-600',
      bg: 'bg-purple-50'
    },
    {
      icon: CheckCircle,
      text: '95% Success Rate',
      color: 'text-green-600',
      bg: 'bg-green-50'
    },
    {
      icon: Star,
      text: '4.9/5 Rating',
      color: 'text-yellow-600',
      bg: 'bg-yellow-50'
    },
    {
      icon: Users,
      text: '10,000+ Happy Students',
      color: 'text-orange-600',
      bg: 'bg-orange-50'
    },
    {
      icon: TrendingUp,
      text: 'Fastest Processing',
      color: 'text-indigo-600',
      bg: 'bg-indigo-50'
    }
  ];

  return (
    <div className="py-8 bg-gray-50 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Title */}
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-1">
            Why 10,000+ Students Trust Visaspot
          </h3>
          <p className="text-sm text-gray-600">
            India's Most Trusted Immigration & Education Consultant
          </p>
        </div>

        {/* Badges Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {badges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div
                key={index}
                className={`${badge.bg} rounded-lg p-4 flex flex-col items-center justify-center text-center transition-transform hover:scale-105 cursor-default`}
              >
                <Icon className={`${badge.color} mb-2`} size={28} />
                <span className="text-xs font-semibold text-gray-900 leading-tight">
                  {badge.text}
                </span>
              </div>
            );
          })}
        </div>

        {/* Bottom Stats Bar */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-3xl font-bold text-blue-600">10,000+</div>
            <div className="text-sm text-gray-600 mt-1">Students Placed</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-3xl font-bold text-green-600">95%</div>
            <div className="text-sm text-gray-600 mt-1">Visa Success Rate</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-3xl font-bold text-orange-600">25+</div>
            <div className="text-sm text-gray-600 mt-1">Countries Served</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBadges;
